import { CommonModule, Location } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, TemplateRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';

/**
 * Componente header riusabile per le pagine di dettaglio
 * Fornisce:
 * - Pulsante back con navigazione automatica
 * - Titolo della pagina
 * - Menu dropdown opzionale
 * - Badge di stato customizzabile
 * - Slot per azioni personalizzate
 */
@Component({
    selector: 'lib-page-header',
    standalone: true,
    imports: [CommonModule, TranslateModule, ButtonModule, MenuModule],
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
    /**
     * Titolo principale dell'header
     */
    @Input() title = '';

    /**
     * Se true, mostra il pulsante back
     */
    @Input() showBackButton = true;

    /**
     * Se true, mostra il menu dropdown
     */
    @Input() showDropdownMenu = false;

    /**
     * Template per il contenuto del lato destro (status + azioni)
     */
    @Input() rightContentTemplate?: TemplateRef<unknown>;

    /**
     * Evento emesso quando viene cliccato il pulsante back
     * Se non gestito dal parent, esegue location.back()
     */
    @Output() backClick = new EventEmitter<void>();

    /**
     * Evento emesso quando viene cliccato il menu dropdown
     */
    @Output() dropdownClick = new EventEmitter<Event>();

    private _location = inject(Location);

    /**
     * Gestisce il click sul pulsante back
     */
    onBackClick(): void {
        if (this.backClick.observed) {
            this.backClick.emit();
        } else {
            // Comportamento di default: torna indietro nella history
            this._location.back();
        }
    }

    /**
     * Gestisce il click sul menu dropdown
     */
    onDropdownClick(event: Event): void {
        this.dropdownClick.emit(event);
    }
}
